
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imprensa",
      function () {
        return require("private-next-pages/imprensa/index.js");
      }
    ]);
  